exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".supplier-list-customer span {\n  font-size: 80%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/accounting/customer/customer-list/customer-list.component.scss
// module id = ../../../../../src/app/agatextscreens/accounting/customer/customer-list/customer-list.component.scss
// module chunks = 0